import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IRemoveCollectionChallengeRequest } from './remove-collection-challenge-request';
import type { IRemoveCollectionChallengeResponse } from './remove-collection-challenge-response';
import { removeCollectionChallengeResponseSchema } from './remove-collection-challenge-response';

export async function removeCollectionChallengeApi({
  collectionId,
  challengeId,
}: IRemoveCollectionChallengeRequest): Promise<
  IValidatedResponse<IRemoveCollectionChallengeResponse>
> {
  return deleteRequest<IRemoveCollectionChallengeResponse>({
    path: `/sys/collections/${collectionId}/challenges/${challengeId}`,
    schema: removeCollectionChallengeResponseSchema,
  });
}
